﻿import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../core/language/language.service';
import { StatisticsService } from './statistics.service';
import { NumberOfDebatesByKind } from '../../core/models/debates/statistics/number-of-debates-by-kind';
import { Chart } from 'chart.js';
import { SearchStatistics } from '../../core/models/debates/statistics/search-statistics';
import { DebateTypeEnum } from '../../core/models/debates/shared/debate-type-enum';
import { GroupingListOfDebatesByYear } from '../../core/models/debates/statistics/grouping-list-of-debates-by-year';
import { NumberOfSessionByLocation } from '../../core/models/debates/statistics/number-of-session-by-location';
import { NumberOfSessionsByDebate } from '../../core/models/debates/statistics/number-of-sessions-by-debate';
import { NumberOfDiscussionsByDebate } from '../../core/models/debates/statistics/number-of-discussions-by-debate';
import { NumberOfParticipantsByDebate } from '../../core/models/debates/statistics/number-of-participants-by-debate';
import { NumberOfCommentsByDebate } from '../../core/models/debates/statistics/number-of-comments-by-debate';
import { NumberOfCommentsByGender } from '../../core/models/debates/statistics/number-of-comments-by-gender';
import { NumberOfCommentsBySensitiveCategory } from '../../core/models/debates/statistics/number-of-comments-by-sensitiveCategory';
import { NumberOfCommentsByYearGroup } from '../../core/models/debates/statistics/number-of-comments-by-yearGroup';
import 'chartjs-plugin-datalabels';

@Component({
    selector: 'app-debates-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {
    private languageID: number;
    public searchModel: SearchStatistics;
    private months: string[] = [];
    public debateTypeEnum = DebateTypeEnum;

    private numberOfDebatesByKind: Array<NumberOfDebatesByKind>;
    private numberOfDebatesByKindTitle: string;
    private numberOfDebatesByKindChart: any;
    private numberOfDebatesByKindChartColors: string[] = ['rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(255, 99, 132, 1)'];

    private numberOfDebatesByMonth: Array<GroupingListOfDebatesByYear>;
    private numberOfDebatesByMonthTitle: string;
    private numberOfDebatesByMonthChart: any;
    private numberOfDebatesByMonthChartColors: string[] = ['rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(175, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 140, 132, 0.5)', 'rgba(54, 122, 235, 0.5)'];

    private numberOfSessionByLocation: Array<NumberOfSessionByLocation>;
    private numberOfSessionByLocationTitle: string;
    private numberOfSessionByLocationChart: any;
    private numberOfSessionByLocationChartColors: string[] = ['rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(175, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 140, 132, 0.5)', 'rgba(54, 122, 235, 0.5)'];

    private numberOfCommentsByDebate: Array<NumberOfCommentsByDebate>;
    private numberOfCommentsByDebateTitle: string;
    private numberOfCommentsByDebateChart: any;
    private numberOfCommentsByDebateChartColors: string[] = ['rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(175, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 140, 132, 0.5)', 'rgba(54, 122, 235, 0.5)'];

    private numberOfCommentsByGender: Array<NumberOfCommentsByGender>;
    private numberOfCommentsByGenderTitle: string;
    private numberOfCommentsByGenderChart: any;
    private numberOfCommentsByGenderChartColors: string[] = ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)'];

    private numberOfCommentsBySensitiveCategory: Array<NumberOfCommentsBySensitiveCategory>;
    private numberOfCommentsBySensitiveCategoryTitle: string;
    private numberOfCommentsBySensitiveCategoryChart: any;
    private numberOfCommentsBySensitiveCategoryChartColors: string[] = ['rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(175, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 140, 132, 0.5)', 'rgba(54, 122, 235, 0.5)'];

    private numberOfCommentsByYearGroup: Array<NumberOfCommentsByYearGroup>;
    private numberOfCommentsByYearGroupTitle: string;
    private numberOfCommentsByYearGroupChart: any;
    private numberOfCommentsByYearGroupChartColors: string[] = ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(175, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(255, 140, 132, 1)', 'rgba(54, 122, 235, 1)'];


    private numberOfSessionsByDebate: Array<NumberOfSessionsByDebate>;
    private numberOfSessionsByDebateTitle: string;
    private numberOfSessionsByDebateChart: any;
    private numberOfSessionsByDebateChartColors: string[] = ['rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(175, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 140, 132, 0.5)', 'rgba(54, 122, 235, 0.5)'];

    private numberOfDiscussionsByDebate: Array<NumberOfDiscussionsByDebate>;
    private numberOfDiscussionsByDebateTitle: string;
    private numberOfDiscussionsByDebateChart: any;
    private numberOfDiscussionsByDebateChartColors: string[] = ['rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(175, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 140, 132, 0.5)', 'rgba(54, 122, 235, 0.5)'];

    private numberOfParticipantsByDebate: Array<NumberOfParticipantsByDebate>;
    private numberOfParticipantsByDebateTitle: string;
    private numberOfParticipantsByDebateChart: any;
    private numberOfParticipantsByDebateChartColors: string[] = ['rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(175, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 140, 132, 0.5)', 'rgba(54, 122, 235, 0.5)'];

    constructor(private _languageService: LanguageService,
        private _statisticsService: StatisticsService) {
        this.languageID = this._languageService.selectedLanguageId;
    }

    ngOnInit() {
        this.translateText();
        const fromDate = new Date();
        fromDate.setMonth(fromDate.getMonth() - 3);
        this.searchModel = {
            languageId: this.languageID,
            debateType: DebateTypeEnum.online,
            dateFrom: fromDate,
            dateTo: new Date()
        }
        this.searchModelChanged();
    }

    translateText() {
        if (this.languageID == 1) {
            this.numberOfDebatesByKindTitle = 'Broj javnih rasprava po vrsti';
            this.numberOfDebatesByMonthTitle = 'Broj javnih rasprava po mjesecima na osnovu datuma početka';
            this.months = ["Jan", "Feb", "Mar", "Apr", "Maј", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            this.numberOfSessionByLocationTitle = 'Broj sesija po lokacijama'; 
            this.numberOfCommentsByDebateTitle = 'Broj komentara po raspravama';
            this.numberOfCommentsByGenderTitle = 'Broj komentara po profilnim podacima (rodna pripadnost)';
            this.numberOfCommentsBySensitiveCategoryTitle = 'Broj komentara po profilnim podacima (osjetljiva kategorija)';
            this.numberOfCommentsByYearGroupTitle = 'Broj komentara po profilnim podacima (starosna grupa)';            
            this.numberOfSessionsByDebateTitle = 'Broj sesija po raspravama';
            this.numberOfDiscussionsByDebateTitle = 'Broj diskusija po raspravama';
            this.numberOfParticipantsByDebateTitle = 'Broj učesnika po raspravama';
        }
        else if (this.languageID == 2) {
            this.numberOfDebatesByKindTitle = 'Број јавних расправа по врсти';
            this.numberOfDebatesByMonthTitle = 'Број јавних расправа по мјесецима на основу датума почетка';
            this.months = ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"];
            this.numberOfSessionByLocationTitle = 'Број сесија по локацијама';
            this.numberOfCommentsByDebateTitle = 'Број коментара по расправама';
            this.numberOfCommentsByGenderTitle = 'Број коментара по профилним подацима (родна припадност)';
            this.numberOfCommentsBySensitiveCategoryTitle = 'Број коментара по профилним подацима (осјетљива категорија)';
            this.numberOfCommentsByYearGroupTitle = 'Број коментара по профилним подацима (старосна група)'; 
            this.numberOfSessionsByDebateTitle = 'Број сесија по расправама';
            this.numberOfDiscussionsByDebateTitle = 'Број дискусија по расправама';
            this.numberOfParticipantsByDebateTitle = 'Број учесника по расправама';
        }
        else {
            this.numberOfDebatesByKindTitle = 'Broj javnih rasprava po vrsti';
            this.numberOfDebatesByMonthTitle = 'Broj javnih rasprava po mjesecima na osnovu datuma početka';
            this.months = ["Jan", "Feb", "Mar", "Apr", "Maј", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            this.numberOfSessionByLocationTitle = 'Broj sesija po lokacijama';
            this.numberOfCommentsByDebateTitle = 'Broj komentara po raspravama';
            this.numberOfCommentsByGenderTitle = 'Broj komentara po profilnim podacima (rodna pripadnost)';
            this.numberOfCommentsBySensitiveCategoryTitle = 'Broj komentara po profilnim podacima (osjetljiva kategorija)'; 
            this.numberOfCommentsByYearGroupTitle = 'Broj komentara po profilnim podacima (starosna grupa)'; 
            this.numberOfSessionsByDebateTitle = 'Broj sesija po raspravama';
            this.numberOfDiscussionsByDebateTitle = 'Broj diskusija po raspravama';
            this.numberOfParticipantsByDebateTitle = 'Broj učesnika po raspravama';
        }
    }

    private getRandomColor() {
        var color = Math.floor(Math.random() * Math.pow(256, 3)).toString(16);
        while (color.length < 6) {
            color = "0" + color;
        }
        return "#" + color;
    }

    private getRandomRGBAColor(transparent:number) {
    var o = Math.round, r = Math.random, s = 255;
        return 'rgba(' + o(r() * s) + ',' + o(r() * s) + ',' + o(r() * s) + ',' + transparent + ')';
}

    searchModelChanged() {
        this.searchModel.debateType = Number(this.searchModel.debateType);
        this.getNumberOfDebatesByKind();
        this.getNumberOfDebatesByMonth();

        if (this.searchModel.debateType == DebateTypeEnum.online) {
            this.getNumberOfDiscussionsByDebate();
            this.getNumberOfCommentsByDebate();
            this.getNumberOfCommentsBySensitiveCategory();
            this.getNumberOfCommentsByGender();
            this.getNumberOfCommentsByYearGroup();
        }

        if (this.searchModel.debateType == DebateTypeEnum.offline) {
            this.getNumberOfSessionByLocation();
            this.getNumberOfSessionsByDebate();
            this.getNumberOfParticipantsByDebate();
        }
    }

    getNumberOfDebatesByKind() {
        this._statisticsService.getNumberOfDebatesByKind(this.searchModel)
            .subscribe(value => {
                this.numberOfDebatesByKind = value;
                this.setNumberOfDebatesByKindChart();
            });
    }

    setNumberOfDebatesByKindChart() {
        if (this.numberOfDebatesByKindChart) {
            this.numberOfDebatesByKindChart.destroy();
        }
        var debateKinds: string[] = [];
        var counts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfDebatesByKind.length > this.numberOfDebatesByKindChartColors.length) {
            for (let i = this.numberOfDebatesByKindChartColors.length; i < this.numberOfDebatesByKind.length; i++) {
                this.numberOfDebatesByKindChartColors.push(this.getRandomColor());
            }
        }
        for (var j = 0; j < this.numberOfDebatesByKind.length; j++) {
            debateKinds[j] = this.numberOfDebatesByKind[j].debateKind;
            counts[j] = this.numberOfDebatesByKind[j].count;
            colors[j] = this.numberOfDebatesByKindChartColors[j];
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfDebatesByKindChart');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfDebatesByKindChart = new Chart(ctxOrg, {
            type: 'bar',

            data: {
                labels: debateKinds,
                datasets: [{
                    data: counts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'bottom',
                        anchor: 'end',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true,
                            precision: 0
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            minRotation: 0,
                            maxRotation: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.numberOfDebatesByKindTitle,
                },
                legend: {
                    display: false
                },
            }

        });
    }

    getNumberOfDebatesByMonth() {
        this._statisticsService.getNumberOfDebatesByMonth(this.searchModel)
            .subscribe(value => {
                this.numberOfDebatesByMonth = value;
                this.setNumberOfDebatesByMonthChart();
            });
    }
    setNumberOfDebatesByMonthChart() {
        if (this.numberOfDebatesByMonthChart) {
            this.numberOfDebatesByMonthChart.destroy();
        }
        const elMonth = <HTMLCanvasElement>document.getElementById('numberOfDebatesByMonthChart');
        const ctx = elMonth.getContext('2d');

        this.numberOfDebatesByMonthChart = new Chart(ctx, {
            type: 'line',
            data: {
                labels: this.months,
                datasets: []
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'end',
                        anchor: 'end',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                title: {
                    display: true,
                    text: this.numberOfDebatesByMonthTitle
                }
            }
        });

        if (this.numberOfDebatesByMonth.length > this.numberOfDebatesByMonthChartColors.length) {
            for (let i = this.numberOfDebatesByMonthChartColors.length; i < this.numberOfDebatesByMonth.length; i++) {
                this.numberOfDebatesByMonthChartColors.push(this.getRandomRGBAColor(0.5));
            }
        }
        var i = 0;

        for (var item of this.numberOfDebatesByMonth) {

            var newDataset = {
                label: item.year,
                backgroundColor: [],
                borderColor: [],
                data: []
            };

            newDataset.backgroundColor.push(this.numberOfDebatesByMonthChartColors[i]);
            newDataset.borderColor.push(this.numberOfDebatesByMonthChartColors[i]);

            for (var monthItem of item.numberOfDebatesByMonthViewModelList) {
                newDataset.backgroundColor.push(this.numberOfDebatesByMonthChartColors[i]);
                newDataset.data.push(monthItem.count);
            }

            this.numberOfDebatesByMonthChart.config.data.datasets.push(newDataset);
            i++;
        }
        this.numberOfDebatesByMonthChart.update();
    }

    getNumberOfSessionByLocation() {
        this._statisticsService.getNumberOfSessionByLocation(this.searchModel)
            .subscribe(value => {
                this.numberOfSessionByLocation = value;
                this.setNumberOfSessionByLocationChart();
            });
    }
    setNumberOfSessionByLocationChart() {
        if (this.numberOfSessionByLocationChart) {
            this.numberOfSessionByLocationChart.destroy();
        }
        var locations: string[] = [];
        var counts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfSessionByLocation.length > this.numberOfSessionByLocationChartColors.length) {
            for (let i = this.numberOfSessionByLocationChartColors.length; i < this.numberOfSessionByLocation.length; i++) {
                this.numberOfSessionByLocationChartColors.push(this.getRandomRGBAColor(0.5));
            }
        }
        for (var j = 0; j < this.numberOfSessionByLocation.length; j++) {
            locations[j] = this.numberOfSessionByLocation[j].location;
            counts[j] = this.numberOfSessionByLocation[j].count;
            colors[j] = this.numberOfSessionByLocationChartColors[j];
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfSessionByLocationChart');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfSessionByLocationChart = new Chart(ctxOrg, {
            type: 'horizontalBar',

            data: {
                labels: locations,
                datasets: [{
                    data: counts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.numberOfSessionByLocationTitle,
                },
                legend: {
                    display: false
                },
            }

        });
    }

    getNumberOfCommentsByDebate() {
        this._statisticsService.getNumberOfCommentsByDebate(this.searchModel)
            .subscribe(value => {
                this.numberOfCommentsByDebate = value;
                this.setNumberOfCommentsByDebateChart();
            });
    }
    setNumberOfCommentsByDebateChart() {
        if (this.numberOfCommentsByDebateChart) {
            this.numberOfCommentsByDebateChart.destroy();
        }
        var debates: string[] = [];
        var counts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfCommentsByDebate.length > this.numberOfCommentsByDebateChartColors.length) {
            for (let i = this.numberOfCommentsByDebateChartColors.length; i < this.numberOfCommentsByDebate.length; i++) {
                this.numberOfCommentsByDebateChartColors.push(this.getRandomRGBAColor(0.5));
            }
        }
        for (var j = 0; j < this.numberOfCommentsByDebate.length; j++) {
            debates[j] = this.numberOfCommentsByDebate[j].debate;
            counts[j] = this.numberOfCommentsByDebate[j].count;
            colors[j] = this.numberOfCommentsByDebateChartColors[j];
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfCommentsByDebateChart');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfCommentsByDebateChart = new Chart(ctxOrg, {
            type: 'horizontalBar',

            data: {
                labels: debates,
                datasets: [{
                    data: counts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.numberOfCommentsByDebateTitle,
                },
          
                legend: {
                    display: false
                },
            }

        });
    }

    getNumberOfCommentsByGender() {
        this._statisticsService.getNumberOfCommentsByGender(this.searchModel)
            .subscribe(value => {
                this.numberOfCommentsByGender = value;
                this.setNumberOfCommentsByGenderChart();
            });
    }
    setNumberOfCommentsByGenderChart() {
        if (this.numberOfCommentsByGenderChart) {
            this.numberOfCommentsByGenderChart.destroy();
        }
        var genders: string[] = [];
        var counts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfCommentsByGender.length > this.numberOfCommentsByGenderChartColors.length) {
            for (let i = this.numberOfCommentsByGenderChartColors.length; i < this.numberOfCommentsByGender.length; i++) {
                this.numberOfCommentsByGenderChartColors.push(this.getRandomColor());
            }
        }
        for (var j = 0; j < this.numberOfCommentsByGender.length; j++) {
            if (this.numberOfCommentsByGender[j].sexId > 0) {
                genders[j] = this.numberOfCommentsByGender[j].sexName;
            }
            else {
                genders[j] = this._languageService.instant('nepoznato');
            }
            counts[j] = this.numberOfCommentsByGender[j].count;
            colors[j] = this.numberOfCommentsByGenderChartColors[j];
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfCommentsByGenderChart');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfCommentsByGenderChart = new Chart(ctxOrg, {
            type: 'pie',

            data: {
                labels: genders,
                datasets: [{
                    data: counts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'end',
                        anchor: 'center',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {

                            var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                            var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                            return value + "(" + percentage + "%)";


                        }
                    }
                },
                title: {
                    display: true,
                    text: this.numberOfCommentsByGenderTitle,
                }
            }

        });
    }

    getNumberOfCommentsBySensitiveCategory() {
        this._statisticsService.getNumberOfCommentsBySensitiveCategory(this.searchModel)
            .subscribe(value => {
                this.numberOfCommentsBySensitiveCategory = value;
                this.setNumberOfCommentsBySensitiveCategoryChart();
            });
    }
    setNumberOfCommentsBySensitiveCategoryChart() {
        if (this.numberOfCommentsBySensitiveCategoryChart) {
            this.numberOfCommentsBySensitiveCategoryChart.destroy();
        }
        var sensitiveCategorys: string[] = [];
        var counts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfCommentsBySensitiveCategory.length > this.numberOfCommentsBySensitiveCategoryChartColors.length) {
            for (let i = this.numberOfCommentsBySensitiveCategoryChartColors.length; i < this.numberOfCommentsBySensitiveCategory.length; i++) {
                this.numberOfCommentsBySensitiveCategoryChartColors.push(this.getRandomRGBAColor(0.5));
            }
        }
        for (var j = 0; j < this.numberOfCommentsBySensitiveCategory.length; j++) {
            if (this.numberOfCommentsBySensitiveCategory[j].sensitiveCategoryId > 0) {
                sensitiveCategorys[j] = this.numberOfCommentsBySensitiveCategory[j].sensitiveCategoryName;
            }
            else {
                sensitiveCategorys[j] = this._languageService.instant('nepoznato');
            }
            counts[j] = this.numberOfCommentsBySensitiveCategory[j].count;
            colors[j] = this.numberOfCommentsBySensitiveCategoryChartColors[j];
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfCommentsBySensitiveCategoryChart');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfCommentsBySensitiveCategoryChart = new Chart(ctxOrg, {
            type: 'horizontalBar',

            data: {
                labels: sensitiveCategorys,
                datasets: [{
                    data: counts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.numberOfCommentsBySensitiveCategoryTitle,
                },
                legend: {
                    display: false
                },
            }

        });
    }

    getNumberOfCommentsByYearGroup() {
        this._statisticsService.getNumberOfCommentsByYearGroup(this.searchModel)
            .subscribe(value => {
                this.numberOfCommentsByYearGroup = value;
                this.setNumberOfCommentsByYearGroupChart();
            });
    }
    setNumberOfCommentsByYearGroupChart() {
        if (this.numberOfCommentsByYearGroupChart) {
            this.numberOfCommentsByYearGroupChart.destroy();
        }
        var yearGroups: string[] = [];
        var counts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfCommentsByYearGroup.length > this.numberOfCommentsByYearGroupChartColors.length) {
            for (let i = this.numberOfCommentsByYearGroupChartColors.length; i < 5; i++) {
                this.numberOfCommentsByYearGroupChartColors.push(this.getRandomColor());
            }
        }


        var ispod18: number = 0;
        var od18do35: number = 0;
        var od35do55: number = 0;
        var preko55: number = 0;
        var nepoznato: number = 0;

        if (this.numberOfCommentsByYearGroup != null && this.numberOfCommentsByYearGroup.length>0) {
            for (let k = 0; k < this.numberOfCommentsByYearGroup.length; k++) {
                if (this.numberOfCommentsByYearGroup[k].numberYear > 0 && this.numberOfCommentsByYearGroup[k].numberYear < 18) {
                    ispod18 += this.numberOfCommentsByYearGroup[k].count;
                }
                if (this.numberOfCommentsByYearGroup[k].numberYear >= 18 && this.numberOfCommentsByYearGroup[k].numberYear < 36) {
                    od18do35 += this.numberOfCommentsByYearGroup[k].count;
                }
                if (this.numberOfCommentsByYearGroup[k].numberYear >= 36 && this.numberOfCommentsByYearGroup[k].numberYear < 56) {
                    od35do55 += this.numberOfCommentsByYearGroup[k].count;
                }
                if (this.numberOfCommentsByYearGroup[k].numberYear >= 56) {
                    preko55 += this.numberOfCommentsByYearGroup[k].count;
                }
                if (this.numberOfCommentsByYearGroup[k].numberYear == 0) {
                    nepoznato += this.numberOfCommentsByYearGroup[k].count;
                }
            }
        }
        yearGroups[0] = this._languageService.instant('Ispod_18');
        yearGroups[1] = '18-35';
        yearGroups[2] = '36-55';
        yearGroups[3] = this._languageService.instant('Preko_55');
        yearGroups[4] = this._languageService.instant('nepoznato');

        counts[0] = ispod18;
        counts[1] = od18do35;
        counts[2] = od35do55;
        counts[3] = preko55;
        counts[4] = nepoznato;

        colors[0] = this.numberOfCommentsByYearGroupChartColors[0];
        colors[1] = this.numberOfCommentsByYearGroupChartColors[1];
        colors[2] = this.numberOfCommentsByYearGroupChartColors[2];
        colors[3] = this.numberOfCommentsByYearGroupChartColors[3];
        colors[4] = this.numberOfCommentsByYearGroupChartColors[4];


        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfCommentsByYearGroupChart');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfCommentsByYearGroupChart = new Chart(ctxOrg, {
            type: 'bar',

            data: {
                labels: yearGroups,
                datasets: [{
                    data: counts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'bottom',
                        anchor: 'end',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            minRotation: 0,
                            maxRotation: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.numberOfCommentsByYearGroupTitle,
                },
                legend: {
                    display: false
                },
            }

        });
    }

    getNumberOfSessionsByDebate() {
        this._statisticsService.getNumberOfSessionsByDebate(this.searchModel)
            .subscribe(value => {
                this.numberOfSessionsByDebate = value;
                this.setNumberOfSessionsByDebateChart();
            });
    }
    setNumberOfSessionsByDebateChart() {
        if (this.numberOfSessionsByDebateChart) {
            this.numberOfSessionsByDebateChart.destroy();
        }
        var debates: string[] = [];
        var sessionCounts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfSessionsByDebate.length > this.numberOfSessionsByDebateChartColors.length) {
            for (let i = this.numberOfSessionsByDebateChartColors.length; i < this.numberOfSessionsByDebate.length; i++) {
                this.numberOfSessionsByDebateChartColors.push(this.getRandomRGBAColor(0.5));
            }
        }
        for (var j = 0; j < this.numberOfSessionsByDebate.length; j++) {
            debates[j] = this.numberOfSessionsByDebate[j].debate;
            sessionCounts[j] = this.numberOfSessionsByDebate[j].sessionCount;
            colors[j] = this.numberOfSessionsByDebateChartColors[j];
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfSessionsByDebate');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfSessionsByDebateChart = new Chart(ctxOrg, {
            type: 'horizontalBar',

            data: {
                labels: debates,
                datasets: [{
                    data: sessionCounts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.numberOfSessionsByDebateTitle,
                },
                legend: {
                    display: false
                },
            }

        });
    }

    getNumberOfDiscussionsByDebate() {
        this._statisticsService.getNumberOfDiscussionsByDebate(this.searchModel)
            .subscribe(value => {
                this.numberOfDiscussionsByDebate = value;
                this.setNumberOfDiscussionsByDebateChart();
            });
    }
    setNumberOfDiscussionsByDebateChart() {
        if (this.numberOfDiscussionsByDebateChart) {
            this.numberOfDiscussionsByDebateChart.destroy();
        }
        var debates: string[] = [];
        var discussionCounts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfDiscussionsByDebate.length > this.numberOfDiscussionsByDebateChartColors.length) {
            for (let i = this.numberOfDiscussionsByDebateChartColors.length; i < this.numberOfDiscussionsByDebate.length; i++) {
                this.numberOfDiscussionsByDebateChartColors.push(this.getRandomRGBAColor(0.5));
            }
        }
        for (var j = 0; j < this.numberOfDiscussionsByDebate.length; j++) {
            debates[j] = this.numberOfDiscussionsByDebate[j].debate;
            discussionCounts[j] = this.numberOfDiscussionsByDebate[j].discussionCount;
            colors[j] = this.numberOfDiscussionsByDebateChartColors[j];
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfDiscussionsByDebate');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfDiscussionsByDebateChart = new Chart(ctxOrg, {
            type: 'horizontalBar',

            data: {
                labels: debates,
                datasets: [{
                    data: discussionCounts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.numberOfDiscussionsByDebateTitle,
                },
                legend: {
                    display: false
                },
            }

        });
    }

    getNumberOfParticipantsByDebate() {
        this._statisticsService.getNumberOfParticipantsByDebate(this.searchModel)
            .subscribe(value => {
                this.numberOfParticipantsByDebate = value;
                this.setNumberOfParticipantsByDebateChart();
            });
    }
    setNumberOfParticipantsByDebateChart() {
        if (this.numberOfParticipantsByDebateChart) {
            this.numberOfParticipantsByDebateChart.destroy();
        }
        var debates: string[] = [];
        var participantsCounts: number[] = [];
        var colors: string[] = [];
        if (this.numberOfParticipantsByDebate.length > this.numberOfParticipantsByDebateChartColors.length) {
            for (let i = this.numberOfParticipantsByDebateChartColors.length; i < this.numberOfParticipantsByDebate.length; i++) {
                this.numberOfParticipantsByDebateChartColors.push(this.getRandomRGBAColor(0.5));
            }
        }
        for (var j = 0; j < this.numberOfParticipantsByDebate.length; j++) {
            debates[j] = this.numberOfParticipantsByDebate[j].debate;
            participantsCounts[j] = this.numberOfParticipantsByDebate[j].participantCount;
            colors[j] = this.numberOfParticipantsByDebateChartColors[j];
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('numberOfParticipantsByDebate');
        const ctxOrg = elOrg.getContext('2d');

        this.numberOfParticipantsByDebateChart = new Chart(ctxOrg, {
            type: 'horizontalBar',

            data: {
                labels: debates,
                datasets: [{
                    data: participantsCounts,
                    backgroundColor: colors,
                    borderColor: colors,
                    borderWidth: 1
                }]
            },

            options: {
                layout: {
                    padding: {
                        left: 80,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {

                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });

                            var currentValue = dataset.data[tooltipItem.index];

                            var precentage = Math.floor(((currentValue / total) * 100) + 0.5);

                            return currentValue + " (" + precentage + "%)";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'start',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            minRotation: 0,
                            maxRotation: 0,
                            precision: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.numberOfParticipantsByDebateTitle,
                },
                legend: {
                    display: false
                },
            }

        });
    }
}
